<template>
  <img src="@/assets/icons/osaka.png" class="mt-10 mr-4"/>
</template>
<script>
export default {
  name: 'AuthLogoOsaka_OSAKA',
}
</script>
